import { createContext } from 'react';
import { ModalSpecification } from 'layout/ModalSpecification';
import { modalState } from './ModalProvider';

export type ModalContextType<TReturn = unknown, TState = unknown> = {
  openModal: (
    spec: ModalSpecification<TReturn, TState>,
    canBeDismissed: boolean,
    state: TState,
  ) => Promise<TReturn>;
  closeAllModals: () => Promise<boolean>;
  closeModal: (key: string, result: TReturn) => Promise<unknown> | undefined;
  state: Record<string, modalState>;
  modals: ModalSpecification<unknown, unknown>[];
};

export const ModalContext = createContext<ModalContextType>(
  {} as unknown as ModalContextType,
);
